// Français pour les trois états vides et la fiche de zone dégradée (src/shared/problems.ts
// EMPTY_TITLE / EMPTY_TEXT, rendus par src/client/components/EmptyState.tsx). Indexé par le
// texte anglais, afin qu'un composant enveloppant la même phrase dans `t()` la reprenne, qu'il
// lise les constantes ou qu'il écrive le texte en clair.
import { registerFr } from './index.js';

registerFr({
  'Could not load': 'Impossible de charger',
  'Nothing matches': 'Rien ne correspond',
  'Nothing here yet': 'Rien ici pour le moment',
  'Nothing was written.': 'Rien n’a été écrit.',
  'Try again': 'Réessayer',
  'Clear the filter': 'Réinitialiser le filtre',
  '{zone} could not be computed': '{zone} n’a pas pu être calculé',
  'The {source} source answered: “{message}”': 'La source {source} a répondu : «{message}»',
}, 'problems');
